//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeProcesRealizace.ts						</Name>
//    <Description> Dialog seznam Procesy realizace polo�ky pl�nu										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-12-01                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.38.1
//AdtGeneratorConfig:[ T:(srvsprr) GID:(Web.Set.Ts) V1:(ixs_prr,nazev,zkratka,poznamka,rok_od,rok_do,ixs_sro_az,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
    export class SeznamAdeProcesRealizace extends GContentBase<SeznamAdeProcesRealizaceDesigner>  {

		//#region *** onContentReady && Init ***

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
        private init() {
			this.createMenuBar();
            SeznamAdeProcesRealizaceDesigner.SeznamAdeProcesRealizaceDesignerInit(this, this.ixs_prr, false);
			this.setTitle();
            this.createGrid();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
				this.title = "jres:33000157" 	//RC 33000157 : Procesy realizace polo�ky pl�nu
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			return this.actions.createBar(["actDetail*", "actSeznamAdeInstitutPredpokladProcesRealizace*"]);
		}

		private createMenuBar(): void {
			this.actions.addRange({
				actNovy: {
					icon: "gi-plus",
					caption: "jres:32000121",			//RC 32000121 : Nov� z�znam
					run: () => {
						var newRecord = true;
						this.openDetail(newRecord);
					}
				},
				actDetail: {
					icon: "gi-detail",
					caption: "jres:32131033",
					run: () => {
						this.openDetail();
					}
				},
				actReload: {
					icon: "gi-refresh",
					caption: "jres:33000084", //RC 33000084 : Obnovit
					run: () => {
						this.beginOperation()
						SeznamAdeProcesRealizaceDesigner.LoadData(this, this.ixs_prr);
						this.grid.ggrid("setData", this.view);
						this.endOperation();
					}
				},
			    actSeznamAdeInstitutPredpokladProcesRealizace: {
					icon: "fa-link",
					caption: "jres:33000163",
					run: (ev, ctx) => {
						this.openSeznamAdeInstitutPredpokladProcesRealizace();
					}
                }
			})
			this.menuBar(this.actions.createBar(
				["actReload*", "actNovy*", "actDetail*", {
					type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
						{
							action: this.actions.actSeznamAdeInstitutPredpokladProcesRealizace
                        }
					]
				}]
			));
		}


		//#endregion

		//#region *** detail ***

		/**
		 * otev��t detail
		 */
        private openDetail(_new?: boolean): void {

            var newRecord = _new == null ? false : _new;

                if (newRecord === true) {
                    // nov� z�znam p�i pr�zdn�m gridu
                    Dialogs.DetailAdeProcesRealizaceDlg(this, { ixs_prr: this.ixs_prr, grid: this.grid, newRecord: newRecord }).done((data: any) => {     });
                }
				else if (Utils.isGridEmpty(this.grid)) {
					SeznamBase.createWarningNot(this, { title: "jres:33000157", text: "jres:32131036", id: "id-flash-select-more-rows-grid-detail" })
                }
            else {

				var selection = this.grid.ggrid("getSelection");

                // vybran� jeden ��dek
				if (selection.length === 1) {
                    var data: any = selection[0];
                    Dialogs.DetailAdeProcesRealizaceDlg(this, { ixs_prr: data.ixs_prr, grid: this.grid, newRecord: newRecord }).done((data: any) => {         });
                }

				// vybr�no v�ce ��dk�
				else {
					SeznamBase.createWarningNot(this, { title: "jres:33000157", text: "jres:32131037", id: "id-flash-select-more-rows-grid-detail" })
				}
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvo�it seznam - definice objektu GRIDu, nav�zan�ch ud�lost� atd... */
		private createGrid(): void {

            this.grid = $("<div>").gautofit().appendTo(this.element);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				dataKey: "ixs_prr",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: this.actions.actDetail,
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
                sort: "ixs_prr",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.actions.actSeznamAdeInstitutPredpokladProcesRealizace?.update({ enabled: obj.count == 1 });
					this.actions.actDetail?.update({ enabled: obj.count == 1 })
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			var panel = this.createPanel();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// o�et�en� zav�en� contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

		private openSeznamAdeInstitutPredpokladProcesRealizace() {
			var selection = this.grid.ggrid("getSelection");
			if (selection.length == 1)
				this.navigate(["Gordic.Adm.WebControls.SeznamAdeInstitutPredpokladProcesRealizace"], { Id: "SeznamAdeInstitutPredpokladProcesRealizace", ixs_prr: selection[0].ixs_prr });
		}

	}

}
